import { render, staticRenderFns } from "./r-smart-offer-skin-dialog.vue?vue&type=template&id=1af16a1b&scoped=true"
import script from "./r-smart-offer-skin-dialog.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-skin-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-smart-offer-skin-dialog.vue?vue&type=style&index=0&id=1af16a1b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af16a1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af16a1b')) {
      api.createRecord('1af16a1b', component.options)
    } else {
      api.reload('1af16a1b', component.options)
    }
    module.hot.accept("./r-smart-offer-skin-dialog.vue?vue&type=template&id=1af16a1b&scoped=true", function () {
      api.rerender('1af16a1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/reskin/r-smart-offer-skin-dialog.vue"
export default component.exports